/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the linked orders loading
 * @returns {any | null} The linked orders loading
 */
const ordersLinkedLoadingSelector = createSelector(ordersSelector, (orders) => orders.linkedOrdersLoading);

export default ordersLinkedLoadingSelector;
